import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import AdFacebookPreview from '../../../../../../features/components/AdFacebookPreview'
import ScalableWrapper from '../ScalableWrapper'

import useElementHeight from '../../../../../../hooks/useElementHeight'
import { transformValuesToFE } from '../../../../../../forms/Facebook/AdForms/AdFacebookEdit/helpers'
import { useGetImageMediaRatio } from '../../../../../../features/components/AdFacebookPreview/hooks'
import {
  getFirstMediaItem,
  getMediaItemImageUrl
} from '../../../../../../features/components/AdFacebookPreview/helpers'

import { facebookImageUrlsSelector, facebookVideoUrlsSelector } from '../../../../../../modules/selectors/mediaFiles'

import useStyles from './styles'

function AdCardPreview({ ad, placementPositions, isAdApprovalsStyle }) {
  const videoUrls = useSelector(facebookVideoUrlsSelector)
  const imageUrls = useSelector(facebookImageUrlsSelector)

  const transformedOriginalValues = useMemo(
    () =>
      transformValuesToFE({
        ad,
        adWasLoaded: true,
        placementPositions,
        imageUrls,
        videoUrls
      }),
    [ad, placementPositions, imageUrls, videoUrls]
  )

  const mediaItem = getFirstMediaItem(transformedOriginalValues)
  // If media is video - initially we represent it as image
  // to get actual image url we use helper function
  const mediaItemImageUrl = getMediaItemImageUrl(mediaItem, imageUrls)
  // Define if media ratio is ready, so we can resize ad preview height
  const { mediaRatio: mediaThumbnailRatio } = useGetImageMediaRatio(mediaItemImageUrl)

  // Here we define resized ad preview height
  const { ref, height } = useElementHeight({
    data: ad,
    // We resize ad preview height only when media ratio (width and height) is ready
    isNodeContentReady: Boolean(mediaThumbnailRatio)
  })

  const classes = useStyles({ previewHeight: height, isAdApprovalsStyle })

  return (
    <div className={classes.adPreviewWrapper}>
      <ScalableWrapper ref={ref} className={classes.scaledAdPreview}>
        <AdFacebookPreview
          isAdApprovalsStyle={isAdApprovalsStyle}
          originalValues={transformedOriginalValues}
          ad={ad}
          placementPositions={placementPositions}
          hideControlsPanel
          isSoundDisabled
        />
      </ScalableWrapper>
    </div>
  )
}

export default AdCardPreview

AdCardPreview.propTypes = {
  ad: PropTypes.object.isRequired,
  isLineItemSummaryPage: PropTypes.bool
}
